import { useLayoutEffect, useRef, useState } from "react"

export interface useShowTooltipProps {
  content?: React.ReactNode
  truncate?: boolean
}
export const useShowTooltip = (props: useShowTooltipProps) => {
  const { content, truncate = false } = props
  const [showTooltip, setShowTooltip] = useState<undefined | boolean>(undefined)

  const ref = useRef<HTMLDivElement>(null)
  useLayoutEffect(() => {
    // 没有content内容 不显示tooltip
    if (!content) {
      setShowTooltip(false)
    }
    // 添加truncate后只有溢出的div才需要天使tooltip内容
    if (ref.current && truncate) {
      setShowTooltip(
        !!content &&
          (ref.current.scrollWidth > ref.current.offsetWidth ||
            ref.current.scrollHeight > ref.current.offsetHeight),
      )
    }
  }, [content, truncate])

  return { showTooltip, ref, setShowTooltip }
}
